import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { mergeMap, Observable } from 'rxjs';
import { DeviceModel } from '../interfaces/allowed-device';
import { UserLevel } from '../models/user-level';

@Injectable({
  providedIn: 'root',
})
export class DeviceModelRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  create(deviceModel: DeviceModel): Observable<void> {
    return this.utils.routeBasedApiUrl('/deviceModels', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.post<void>(url, deviceModel)),
      wrapError('device-model-repository:create')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceModels/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('device-model-repository:delete')
    );
  }

  list(): Observable<DeviceModel[]> {
    return this.utils.routeBasedApiUrl('/deviceModels', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.get<DeviceModel[]>(url)),
      wrapError('device-model-repository:list')
    );
  }

  listForEnterprise(): Observable<DeviceModel[]> {
    return this.utils.apiUrl('/deviceModels').pipe(
      mergeMap((url) => this.http.get<DeviceModel[]>(url)),
      wrapError('device-model-repository:list-for-enterprise')
    );
  }

  update(id: number, deviceModel: DeviceModel): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceModels/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.put<void>(url, deviceModel)),
      wrapError('device-model-repository:update')
    );
  }
}
